module.exports = __webpack_public_path__ + "images/areamap/btn_mappin_kanto_sp_f1bb702ba8268678ffaea68c71c6e5a3.png";